import React from 'react';
import win from "../assets/images/win.png";
import Wallpaper1 from "../assets/images/wallpaper1.jpg";

function WinScreen() {
    return (
        <div className="result-block">
            <p>Thanks for participating</p>
            <h2>YOU HAVE FINISHED THE PUZZLE SUCCESSFULLY</h2>
            <div className="poster">
                <div className="overlay-text">
                    <p>A customised wallpaper (to the theme of Raabta)</p>
                    click{" "}
                    <a href={Wallpaper1} download="Raabta-Wallpaper.jpg">
                        here
                    </a>{" "}
                    to download
                </div>
            </div>
            <p>
                Stay tuned! Top participants get <strong>₹20 cashback</strong> and a chance to win exciting prizes
            </p>
            <img className="win-img" src={win} alt="logo-prize" />
        </div>
    );
}

export default WinScreen;
